<template>
  <div>
    <TitleCard title="分组详情" style="max-width: 97%; margin: 10px auto">
      <template v-slot:subTitle class="position-relative">
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li
              class="breadcrumb-item text-muted"
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap"
              style="font-family: 'Roboto', sans-serif"
          >
            Travel Group Detail
          </li>
          <div
              class="align-items-center py-3"
              style="position: absolute; right: 0; padding: 0 40px"
          >
            <el-button type="primary" size="small" style="margin-right: 5px" @click="openDeleteWindow(null)" :disabled="idArrs.length==0">批量删除线路</el-button>
            <el-button type="primary" size="small" style="margin-right: 10px" @click="batchPush" :disabled="idArrs.length==0">批量推送</el-button>
            <el-button size="small" style="margin-right: 10px" type="primary" @click="configureGoods">线路配置
            </el-button>
            <el-button size="small" type="primary" @click="$router.replace('/travel/travel_group')">返回到分组管理
            </el-button>
          </div>
        </ul>
      </template>
    </TitleCard>
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div
          id="kt_content_container"
          class="container"
          style="
          max-width: 98%;
          flex-direction: row !important;
          display: flex;
        "
      >
        <!-- 搜索开始 -->
        <div
            class="flex-column flex-lg-row-auto w-100 w-lg-250px w-xxl-325px mb-8 mb-lg-0 me-lg-9 me-5"
        >
          <form action="#" id="group_form1">
            <div class="card">
              <div class="card-body" style="padding: 1.2rem 1rem">
                <div class="separator separator-dashed my-8"></div>
                <div class="mb-5">
                  <label class="fs-6 form-label er text-dark fw-bold"
                  >线路标题</label
                  >
                  <div class="position-relative">
                    <span
                        class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                    >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                      >
                        <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24"></rect>
                          <path
                              d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                              fill="#000000"
                              fill-rule="nonzero"
                              opacity="0.3"
                          ></path>
                          <path
                              d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                              fill="#000000"
                              fill-rule="nonzero"
                          ></path>
                        </g>
                      </svg>
                    </span>
                    <input
                        id="title"
                        type="text"
                        class="form-control form-control-solid ps-10"
                        name="search"
                        v-model="params.title"
                        value=""
                        placeholder="请输入需要查询的线路标题"
                    />
                  </div>
                </div>

                <div class="d-flex align-items-center justify-content-end">
                  <a
                      @click="shaixuan"
                      href="javascript:void(0);"
                      class="btn btn-primary fw-bold"
                  >筛选</a
                  >&nbsp;&nbsp;&nbsp;
                  <a
                      @click="resetQuery"
                      href="javascript:void(0);"
                      class="btn btn-active-light-primary btn-color-gray-400 me-3 fw-bold"
                  >重置</a
                  >
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- 列表开始 -->
        <div
            class="card mb-5 mb-xl-8"
            style="margin-left: 3px; width: 100%"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            v-loading="loading"
        >
          <div class="card-body py-3" style="padding-left: 15px">
            <div class="table-responsive">
              <table
                  class="table align-middle table-row-dashed table-hover fs-6 gy-5 dataTable no-footer"
                  id="kt_ecommerce_products_table"
              >
                <thead>
                <tr
                    class="text-start text-gray-500  fs-7 text-uppercase gs-0"
                >
                  <th
                      class="w-10px pe-2 sorting_disabled"
                      rowspan="1"
                      colspan="1"
                      aria-label=""
                      style="width: 2%"
                  >
                    <div
                        class="form-check form-check-sm form-check-custom form-check-solid me-3"
                    >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          data-kt-check="true"
                          data-kt-check-target="#kt_ecommerce_products_table .form-check-input"
                          value="TRUE"
                          v-model="checkboxInput"
                          @change="checkboxInputEvent"
                      />
                    </div>
                  </th>
                  <th
                      class="max-w-140px"
                      tabindex="0"
                      aria-controls="kt_ecommerce_products_table"
                      rowspan="1"
                      colspan="1"
                      aria-label="Product: activate to sort column ascending"
                      style="min-width: 17%"
                  >
                    线路信息
                  </th>
                  <th
                      class="max-w-140px"
                      tabindex="0"
                      aria-controls="kt_ecommerce_products_table"
                      rowspan="1"
                      colspan="1"
                      aria-label="Product: activate to sort column ascending"
                      style="min-width: 17%"
                  >
                    副标题
                  </th>

                  <th
                      class="text-center min-w-100px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="市场价"
                      style="width: 6%"
                  >
                    市场价
                  </th>

                  <th
                      class="text-center min-w-100px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="定金"
                      style="width: 5%"
                  >
                    定金
                  </th>

                  <th
                      class="text-center min-w-100px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="状态"
                      style="width: 6%"
                  >
                    状态
                  </th>
                  <th
                      class="text-center min-w-150px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="更新时间"
                      style="width: 9%"
                  >
                    创建时间
                  </th>
                  <th
                      class="text-center min-w-100px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="操作"
                      style="width: 3%"
                  >
                    操作
                  </th>
                </tr>
                </thead>
                <tbody class="fw-semibold text-gray-600">
                <tr
                    v-for="(item, index) in rows"
                    :class="{ old: index % 2 == 0, even: index % 2 != 0 }"
                    :key="index"
                >

                  <!-- 复选按钮 -->
                  <td>
                    <div
                        class="form-check form-check-sm form-check-custom form-check-solid"
                    >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          value="1"
                          @click="addIdArr(item.id)"
                          :checked="idArrs.includes(item.id)"
                      />
                    </div>
                  </td>
                  <!-- 商品信息 -->
                  <td style="padding-right: 0">
                    <div
                        class="d-flex align-items-center"
                        @click="
                          openGoodInfo(item.id)
                        "
                    >
                      <a href="javascript:void(0)" class="symbol symbol-50px">

                        <img
                            class="symbol-label lozad"
                            v-if="item.picUrl.indexOf('http') == 0"
                            :src="`${item.picUrl}`"
                        />
                        <img
                            class="symbol-label lozad"
                            v-else
                            :src="`https://www.3jzc.cn${item.picUrl}`"
                        />
                      </a>
                      <div
                          style="
                            max-width: 170px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            margin-left: 10px;
                          "
                      >
                        <a
                            href="javascript:void(0)"
                            :title="item.title"
                            class="text-gray-800 text-hover-primary fs-5 "
                            data-kt-ecommerce-product-filter="product_name"
                        >{{ item.title }}</a
                        >
                      </div>
                    </div>
                  </td>
                  <!-- 分类 -->
                  <td class="text-center pe-0">
                    <div
                        class=""
                        style="font-size: 90%"
                        v-html="item.subTitle"
                    ></div>
                  </td>
                  <!-- 市场价 -->
                  <td
                      class="text-center pe-0 text-black "
                  >
                      <span
                          class=""
                          style="
                          font-size: 90%;
                        "
                      >
                        {{ item.price | format }}
                      </span>
                  </td>

                  <!-- 销量 -->
                  <td class="text-center pe-0">
                      <span
                          class=""
                          style="
                          font-size: 90%;
                        "
                      >
                        {{ item.deposit | format }}
                      </span>
                  </td>

                  <td class="text-center pe-0">
                    <span
                        class="text-center "
                    >
                      <span
                          class="badge fs-7 "
                          :class="item.isShow != '未上架'? 'badge-light-success' :'badge-light-danger'"
                          style="
                          display: block;
                          text-align: center;
                          margin: 0 auto;
                        "
                          v-html="item.isShow"
                      >
                      </span>

                    </span>
                  </td>
                  <!-- 更新时间 -->
                  <td class="text-center pe-0">
                    <span class="">{{ item.crTime }}</span>
                  </td>
                  <td>
                    <el-button type="text" class="custom-text-button text-hover-info text-black"
                             @click="openDeleteWindow(item.id)">删除</el-button>
                  </td>
                </tr>
                </tbody>
              </table>
              <Pagination
                  :total-items="totalCount"
                  @page-change="pageChange"
              ></Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  商品详情  -->
    <ModalDialog title="线路详情" id="goodInfo" ref="goodInfo" width="1000px">
      <TravelInfoComponent ref="goodInfoComponent"></TravelInfoComponent>
    </ModalDialog>

    <ModalDialog id="configureSjGoods" ref="configureSjGoods" title="配置线路" width="98%">
      <template v-slot:header-buttons>
        <button class="btn btn-primary btn-sm" @click="addGoods">
          批量添加进分组
        </button>
      </template>
      <OwnGoodsList ref="OwnGoodsList" :groupId="goodsGroupId" @setArrId="setIdArr" @setIsJd="setIsJd"></OwnGoodsList>
    </ModalDialog>

    <ModalDialog :title="userRole.includes('vipMember')?'配置商会商品池商品':'配置商品池商品'" id="configurePoolGoods" ref="configurePoolGoods" width="98%">
      <template v-slot:header-buttons>
        <button class="btn btn-primary btn-sm" @click="addGoods">
          批量添加进分组
        </button>
      </template>
      <PoolGoodsList ref="ChooseGoods" :groupId="goodsGroupId" @setPoolIdArr="setIdArr" @setPoolIsJd="setIsJd"></PoolGoodsList>
    </ModalDialog>
    <!-- 推送 -->
    <ModalDialog
        title="批量推送"
        id="pushGoodsAll"
        ref="pushGoodsAll"
        width="850px"
    >
      <div>
        <el-form ref="form" :model="pushGoodsObj" label-width="80px">
          <el-form-item label="推送目标" :required="true">
            <el-checkbox-group v-model="pushGoodsObj.selectionObjects">
              <el-checkbox label="shop">精选目的地</el-checkbox>
<!--              <el-checkbox label="topic">活动</el-checkbox>-->
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="已选商品">
            <span style="color: red">{{ idArrs.length }} </span> 件商品
          </el-form-item>
          </el-form-item>
        </el-form>
      </div>
      <el-button
          type="primary"
          style="float: right; margin-right: 20px"
          @click="nextPush"
      >下一步<i class="el-icon-arrow-right el-icon--right"></i
      ></el-button>
    </ModalDialog>
    <ModalDialog
        title="选择具体推送目标"
        id="pushGrounp"
        ref="pushGrounp"
        :width="pushGoodsObj.selectionObjects.length * 400 + 'px'"
    >
      <div style="display: flex">
        <div
            style="width: 400px; flex: 1; height: 400px; overflow-y: scroll"
            v-if="pushGoodsObj.selectionObjects.includes('shop')"
        >
          <h3>精选目的地</h3>
          <div>
            <el-tree
                :data="shopProps"
                show-checkbox
                node-key="id"
                ref="shopTree"
            >
            </el-tree>
          </div>
        </div>
        <div
            style="width: 400px; flex: 1; height: 400px; overflow-y: scroll"
            v-if="pushGoodsObj.selectionObjects.includes('topic')"
        >
          <h3>活动</h3>
          <div>
            <el-tree
                :data="topicProps"
                ref="topicTree"
                node-key="id"
                show-checkbox
            >
            </el-tree>
          </div>
        </div>
      </div>
      <el-divider></el-divider>

      <el-button
          type="primary"
          style="float: right; margin-right: 20px"
          @click="submitPush"
      >提交&nbsp;&nbsp;<i class="el-icon-arrow-right el-icon--right"></i
      ></el-button>
      <el-button
          type="primary"
          style="float: right; margin-right: 20px"
          @click="$refs.pushGrounp.close()"
      >上一步<i class="el-icon-arrow-left el-icon--left"></i
      ></el-button>
    </ModalDialog>
  </div>
</template>
<script>
// 导入数据api
import {
  getReviewedPoolGoodsCountApi,
  getReviewedPoolGoodsListApi,
  getReviewedTravelCountApi,
  getReviewedTravelListApi,
} from "@/api/travleManageApi";

import TravelInfoComponent from "@/components/TravelInfoComponent";
// 页码指定跳转
import Pagination from "@/components/Pagination/index.vue";
import {getCategoryList} from "@/api/categoryApi";
// 导入组件
import SelectionGoods from "@/views/Goods/components/GoodsManage/components/SelectionedGoods/SelectionedGoodsList.vue";
import OwnGoodsList from "@/views/TravelGroupManage/components/OwnGoods/OwnGoodsList.vue";
//import ChooseGoods from "@/views/ChooseGoods";
import PoolGoodsList from "@/views/GroupManage/components/PoolGoods/PoolGoodsList.vue";
import {
  addGoodsApi,
  deleteGoodsInGroupApi,
  getDestinationByStaffIdApi,
  getWxTopicByStaffIdApi
} from "@/api/groupGoodsApi";
import {selectionGoodsApi} from "@/api/chooseGoodsApi";

export default {
  components: {
    PoolGoodsList,
    Pagination,
    TravelInfoComponent,
    SelectionGoods,
    OwnGoodsList,
    //ChooseGoods
  },
  data() {
    return {
      idArrs: [],
      goodsGroupId: "",
      staffArr: [], // 几级供应商
      selTypeId: 0, // 场景范围id
      selType: "",  // 搜索场景类型
      categoryOne: [],
      categoryTwo: [],
      idArr: [],
      rows: [],
      selArr: [],  // 场景范围数组
      checkboxInput: false,
      loading: false,
      // 拆线呢查询传参
      params: {
        current: 1,
        size: 10,
        title: "",
        categoryId1: "",
        categoryId2: "",
        isShow: 1,
        isTwoShow: 1,
        isJd: 2,
        goodsGroupId: 0,
        goodsStaffId: "",
        sevenNRR: "",
        maxRightRate: "",
        minRightRate: "",
        deliveryTime: ""
      },
      deliveryTime: [],
      // componentTransmission
      componentParams: {
        current: 1,
        size: 10,
        spuId: "",
        title: "",
        categoryId1: "",
        categoryId2: "",
        isShow: "",
        stock: "",
        isQuan: "",
        status: "",
        minStock: "",
        maxStock: "",
        isJd: 2,
        goodsGroupId: 0,
        shopId: "",
        topicId: "",
        goodsStaffId: ""
      },
      goodsPlace: 1,   // 1 自有 2 商品池
      totalCount: 999,
      first: true,
      isJd: 2,
      groupProps: [],
      shopProps: [],
      topicProps: [],
      unitOptions: [
        {
          value: "1",
          label: "%",
        },
        {
          value: "2",
          label: "元",
        },
      ],
      adjustOptions: [
        //{
        //  value: "1",
        //  label: "上调",
        //},
        {
          value: "2",
          label: "下降",
        },
      ],
      options: [
        //{
        //  value: "1",
        //  label: "销售价",
        //},
        {
          value: "2",
          label: "市场价",
        },
        {
          value: "3",
          label: "分销价",
        },
      ],
      pushGoodsObj: {
        topicIds: [],
        shopIds: [],
        selectionObjects: [],
        goodsIds: [],
        isJd: 1,
        salePriceChange: "2",
        salePriceDto: {
          salePriceReference: "2",
          salePriceAdjust: "2",
          salePriceNum: "",
          salePriceUnit: "1",
        },
      },
      userRole: localStorage.getItem("role")
    }
  },
  // 方法
  methods: {
    async submitPush(id) {
      this.pushGoodsObj.topicIds = [];
      this.pushGoodsObj.shopIds = [];
      this.pushGoodsObj.goodsGroupIds = [];
      this.pushGoodsObj.goodsIds = [];
      if (this.pushGoodsObj.selectionObjects.includes("topic")) {
        this.pushGoodsObj.topicIds = this.$refs.topicTree.getCheckedKeys();
        if (this.pushGoodsObj.topicIds.length == 0) {
          let index = this.pushGoodsObj.selectionObjects.indexOf("topic");
          this.pushGoodsObj.selectionObjects.splice(index, 1);
        }
      }
      if (this.pushGoodsObj.selectionObjects.includes("shop")) {
        this.pushGoodsObj.shopIds = this.$refs.shopTree.getCheckedKeys();
        if (this.pushGoodsObj.shopIds.length == 0) {
          let index = this.pushGoodsObj.selectionObjects.indexOf("shop");
          this.pushGoodsObj.selectionObjects.splice(index, 1);
        }
      }
      /*if (this.pushGoodsObj.selectionObjects.includes("group")) {
        this.pushGoodsObj.goodsGroupIds = this.$refs.groupTree.getCheckedKeys();
        if (this.pushGoodsObj.goodsGroupIds.length == 0) {
          let index = this.pushGoodsObj.selectionObjects.indexOf("group");
          this.pushGoodsObj.selectionObjects.splice(index, 1);
        }
      }*/
      /* if (this.pushGoodsObj.supplPriceChange == "2") {
         this.pushGoodsObj.supplPriceDto = {
           supplPriceReference: "",
           supplPriceAdjust: "",
           supplPriceNum: "",
           supplPriceUnit: "",
         };
       }
       if (this.pushGoodsObj.salePriceChange == "2") {
         this.pushGoodsObj.salePriceDto = {
           salePriceReference: "",
           salePriceAdjust: "",
           salePriceNum: "",
           salePriceUnit: "",
         };
       }*/
      this.pushGoodsObj.goodsIds = this.idArrs;
      this.pushGoodsObj.isJd = this.isJd;

      let arr = ["group", "shop", "topic"];
      let arr1 = [];
      arr.forEach((item) => {
        if (this.pushGoodsObj.selectionObjects.includes(item)) {
          arr1.push(item);
        }
      });
      let {data} = await selectionGoodsApi(this.pushGoodsObj);
      this.$message({
        message: "推送成功",
        type: "success",
      });
      this.$refs.pushGoodsAll.close();
      this.$refs.pushGrounp.close();
    },
    async nextPush() {
      if (this.pushGoodsObj.selectionObjects.length == 0) {
        this.$message({
          message: "请选择推送目标",
          type: "warning",
        });
        return;
      }

      this.$refs.pushGrounp.open();
    },
    async batchPush() {
      this.isJd = 2;
      if (this.goodsPlace === 1) {
        this.isJd = 2;
      } else {
        this.isJd = this.componentParams.isJd;
      }
      if (this.idArrs.length == 0) {

        this.$swal.fire({
          icon: "warning",
          title: "请先选择线路",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });

        return;
      }
      this.$refs.pushGoodsAll.open();
      this.shopProps = []; //轮播
      this.topicProps = []; //活动
      this.groupProps = [];
      let {data: res1} = await getWxTopicByStaffIdApi();
      res1.forEach((item, index) => {
        this.topicProps.push({
          id: item.id,
          label: item.title,
        });
      });
     // let {data: res2} = await getWxShopByStaffIdApi();
      let {data: res2} = await getDestinationByStaffIdApi();
      res2.forEach((item, index) => {
        this.shopProps.push({
          id: item.id,
          label: item.title,
        });
      });
      /*let {data: res3} = await getGoodsGroupByStaffIdApi();
      res3.forEach((item, index) => {
        this.groupProps.push({
          id: item.id,
          label: item.name,
        });
      });*/

    },
    addGoods() {
      this.$confirm('确定将商品推送至当前分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {

        if (this.idArr.length <= 0) {
          this.$swal.fire({
            icon: "warning",
            title: "请上先选择线路",
            toast: true,
            position: "center",
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }

        let {data} = await addGoodsApi({
          goodsGroupIds: [this.goodsGroupId],
          isJd: this.componentParams.isJd,
          goodsIds: this.idArr,
          type:2,
        })
        this.$refs.ChooseGoods.reloadIdArr();
        this.$refs.OwnGoodsList.reloadIdArr();
        this.$refs.configurePoolGoods.close();
        this.$refs.configureSjGoods.close();
        this.$message({
          type: 'success',
          message: '推送成功!'
        });
        console.log(this.goodsPlace)
        if (this.goodsPlace == 1){
          this.getTravelList();
        } else {
          this.getPoolGoodsList();
        }
      }).catch(() => {

      });
    },


    configureGoods() {
      //this.params.isJd = item;
      this.componentParams.isJd = 2;
      this.$refs.OwnGoodsList.reloadIdArr();
      this.$refs.OwnGoodsList.getTravelList();
      this.$refs.configureSjGoods.open();
    },
    // 选择商城还是选择活动等等
    changeQuery() {
      this.first = true
      if (this.goodsPlace == 1) {
        this.getTravelList()
      } else {
        this.getPoolGoodsList()
      }
    },
    setIsJd(param) {
      this.componentParams = param
    },
    setIdArr(idArr) {
      this.idArr = idArr
    },
    checkboxInputEvent() {
      if (this.checkboxInput) {
        this.rows.forEach((e) => {
          if (!this.idArrs.includes(e.id)) {
            this.idArrs.push(e.id);
          }
        });
      } else {
        this.rows.forEach((e) => {
          let index = this.idArrs.indexOf(e.id);
          if (index !== -1) {
            this.idArrs.splice(index, 1);
          }
        });
      }
    },
    async addIdArr(id) {
      if (this.idArrs.includes(id)) {
        let index = this.idArrs.indexOf(id);
        if (index !== -1) {
          this.idArrs.splice(index, 1);
        }
      } else {
        this.idArrs.push(id);
      }
      let a = true;
      this.rows.forEach((e) => {
        if (!this.idArrs.includes(e.id)) {
          a = false;
        }
      });
      if (this.rows, length == 0) {
        a = false
      }
      this.checkboxInput = a;
    },
    openGoodInfo(id, isJd) {
      this.$refs.goodInfo.open();
      this.$refs.goodInfoComponent.openGoodsInfo(id, isJd);
      // console.log("打开商品详情",id);
    },
    // 分页查询 自有商品
    async getTravelList() {
      this.checkboxInput = false;
      this.loading = true;
      this.params.goodsGroupId = this.$route.params.id;
      let {data} = await getReviewedTravelListApi(this.params);
      this.loading = false;
      this.first = true;
      this.rows = data.rows;
      if (this.first) {
        this.getTravelPageCount();
      }
      this.first = false;
      let a = true;
      this.rows.forEach((e) => {
        if (!this.idArrs.includes(e.id)) {
          a = false;
        }
      });
      if (this.rows, length == 0) {
        a = false
      }
      this.checkboxInput = a;
    },

    // 分页查询 商品池商品
    async getPoolGoodsList() {
      this.checkboxInput = false;
      this.loading = true;
      this.first = true;
      this.params.goodsGroupId = this.$route.params.id;
      let {data} = await getReviewedPoolGoodsListApi(this.params);
      this.loading = false;
      this.rows = data.rows;
      if (this.first) {
        this.getPoolGoodsPageCount();
      }
      this.first = false;
      let a = true;
      this.rows.forEach((e) => {
        if (!this.idArrs.includes(e.id)) {
          a = false;
        }
      });
      this.checkboxInput = a;
    },

    pageChange(currentPage, pageSize) {
      this.params.current = currentPage;
      this.params.size = pageSize;
      if (this.deliveryTime.length > 0) {
        this.params.deliveryTime = this.deliveryTime.join(',');
      } else {
        this.params.deliveryTime = "";
      }
      if (this.goodsPlace == 1) {
        this.getTravelList();
      } else {
        this.getPoolGoodsList();
      }
    },
    async getTravelPageCount() {
      let {data} = await getReviewedTravelCountApi(this.params);
      this.totalCount = data;
    },
    async getPoolGoodsPageCount() {
      let {data} = await getReviewedPoolGoodsCountApi(this.params);
      this.totalCount = data;
    },
    toggleDropdown(index) {
      this.$nextTick(() => {
        const dropdown = document.getElementById(`dropdown-${index}`);
        new KTMenu(dropdown);
      });
    },
    // 筛选
    shaixuan() {
      this.idArrs = []
      this.first = true;
      if (this.deliveryTime.length > 0) {
        this.params.deliveryTime = this.deliveryTime.join(',');
      } else {
        this.params.deliveryTime = "";
      }
      if (this.goodsPlace == 1) {
        this.getTravelList();
      } else {
        this.getPoolGoodsList();
      }
    },
    // 重置
    resetQuery (){
      this.deliveryTime= [];
      this.params = {
        current: 1,
        size: 10,
        title: "",
        categoryId1: "",
        categoryId2: "",
        isShow: 1,
        isTwoShow: 1,
        isJd: this.params.isJd,
        goodsGroupId: 0,
        goodsStaffId: "",
        sevenNRR: "",
        maxRightRate: "",
        minRightRate: "",
        deliveryTime: ""
      }
      this.first = true
      if (this.deliveryTime.length > 0) {
        this.params.deliveryTime = this.deliveryTime.join(',');
      } else {
        this.params.deliveryTime = "";
      }
      if (this.goodsPlace == 1) {
        this.getTravelList();
      } else {
        this.getPoolGoodsList();
      }
    },
    async findCategory(index) {
      this.first = true;
      if (index == 1) {
        if (!this.params.categoryId1){
          this.params.categoryId1 = 0;
          this.params.categoryId2 = "";
          this.categoryTwo = [];
        }
        let {data} = await getCategoryList({
          parentId: this.params.categoryId1,
        });
        if (this.params.categoryId1 !== 0) {
          this.categoryTwo = data.list;
        }
      }
      if (this.params.categoryId1 === 0){
        this.params.categoryId1 = "";
      }
      if (this.deliveryTime.length > 0) {
        this.params.deliveryTime = this.deliveryTime.join(',');
      } else {
        this.params.deliveryTime = "";
      }
      if (this.goodsPlace == 1) {
        this.getTravelList();
      } else {
        this.getPoolGoodsList();
      }
    },

    // 点击自由商品和商品池商品
    ownReviewedGoods(goodsPlace, place) {
      this.idArrs = []
      this.idArr = []
      this.selType = goodsPlace == 1 ? "" : "group"
      this.selTypeId = 0;
      //this.selType="group";
      this.componentParams.goodsGroupId = "0";
      this.componentParams.shopId = "";
      this.componentParams.topicId = "";
      this.goodsPlace = goodsPlace;
      if (place) {
        this.componentParams.isJd = place;
        this.params.isJd = place;
      } else {
        this.componentParams.isJd = 2;
        this.params.isJd = 2;
      }
      this.params.current = 1;
      if (goodsPlace == 1) {
        this.getTravelList();
      } else {
        this.getPoolGoodsList();
      }
    },

    // 父类index使用
    createGoods() {
    },
    // 按照价格改变时 调整方式需要改变
    changeSalePrice () {
      if (this.pushGoodsObj.salePriceDto.salePriceReference == 2) {
        this.pushGoodsObj.salePriceDto.salePriceAdjust = "2";
        this.adjustOptions = [
          {
            value: "2",
            label: "下降",
          },
        ]
      } else {
        this.adjustOptions = [
          {
            value: "1",
            label: "上调",
          },
          {
            value: "2",
            label: "下降",
          },
        ]
      }
    },
    // 打开弹窗并删除
    openDeleteWindow (goodId){
      let msg = "";
      if (goodId) {
        msg = "你是否删除该线路";
        this.idArrs = [goodId];
      } else {
        msg = "你是否删除选中的所有线路";
      }

      if (this.idArrs.length == 0) {
        this.$swal.fire({
          icon: "warning",
          title: "请先选择线路再删除",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });

        return;
      }

      let arr = Array.from(this.idArrs)
      let groupId = [this.goodsGroupId]
      this.$confirm(`${msg}`, `是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      }).then(async () => {
        await deleteGoodsInGroupApi({
          goodsIds: arr,
          goodsGroupIds: groupId,
        });
        this.$message({
          type: "success",
          message: "删除成功!",
        });
        if (this.goodsPlace == 1) {
          this.getTravelList();
        } else {
          this.getPoolGoodsList();
        }
      }).catch(() => {
      });

    },
    // 将多选改成单选
    setTree(data,typeName){
      this.$refs[typeName].setCheckedKeys([]);
      if (data){
        this.$refs[typeName].setCheckedNodes([data]);
      }
    },
    groupTreeNodeClick(data){
      this.setTree(data,"groupTree")
    },
    shopTreeNodeClick(data){
      this.setTree(data,"shopTree")
    },
    topicTreeNodeClick(data){
      this.setTree(data,"topicTree")
    },
  },
  // 初始化这个方法
  created() {
    if (this.$route.params.id) {
      this.params.goodsGroupId = this.$route.params.id;
      this.goodsGroupId = this.$route.params.id;
      this.getTravelList();
    }
  },

  updated() {
    // 当数据更新后，可以在此处手动初始化下拉菜单插件
    this.rows.forEach((_, index) => {
      this.toggleDropdown(index);
    });
  },
};
</script>
<!--组件样式-->
<style scoped>
.borderHover:hover {
  border-color: rgb(0, 158, 247) !important;
}

/* 修改滚动条样式 */
.table-responsive::-webkit-scrollbar {
  width: 20px; /* 设置滚动条宽度 */
  height: 15px;
  background-color: #F5F5F5; /* 设置滚动条背景颜色 */
}

.table-responsive::-webkit-scrollbar-thumb {
  background-color: #888; /* 设置滚动条滑块颜色 */
  border-radius: 5px; /* 设置滚动条滑块圆角 */
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* 设置滚动条滑块在鼠标悬停时的颜色 */
}

</style>
